import { render, staticRenderFns } from "./Inscriptions-dog-documents-comp.vue?vue&type=template&id=3124bd72&scoped=true&"
import script from "./Inscriptions-dog-documents-comp.vue?vue&type=script&lang=js&"
export * from "./Inscriptions-dog-documents-comp.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions-dog-documents-comp.vue?vue&type=style&index=0&id=3124bd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3124bd72",
  null
  
)

export default component.exports